/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { Notification } from '../../utils/utils';
import { StoresForMap, StoresMapFilterParams } from '../api/stores/storesClientTypings';
import { Viewport } from '../../components/Map/typings';

export enum StoresMapActionType {
    OPEN_STORES_MAP_PAGE = 'Stores map / open page',
    EXIT_STORES_MAP_PAGE = 'Stores map / exit page',

    VIEWPORT_CHANGE = 'Stores map / viewport change',
    APPLY_FILTERS = 'Stores map / apply filters',
    CHANGE_FILTER_PARAMS = 'Stores map / change filter params',

    FETCH_STORES_SUCCESS = 'Stores map / fetch stores success',
    FETCH_STORES_ERROR = 'Stores map / fetch stores error',
}

export const openMapPageAction = () => createAction(StoresMapActionType.OPEN_STORES_MAP_PAGE);

export const closeMapPageAction = () => createAction(StoresMapActionType.EXIT_STORES_MAP_PAGE);

export const applyFilteringAction = () => createAction(StoresMapActionType.APPLY_FILTERS);

export const fetchStoresSuccessAction = (stores: StoresForMap) =>
    createAction(StoresMapActionType.FETCH_STORES_SUCCESS, stores);

export const changeFilterParamsAction = (filterParams: StoresMapFilterParams) =>
    createAction(StoresMapActionType.CHANGE_FILTER_PARAMS, filterParams);

export const fetchStoresErrorAction = (notification: Notification) =>
    createAction(StoresMapActionType.FETCH_STORES_ERROR, { notification });

export const viewportChangeActon = (viewport: Viewport) => createAction(StoresMapActionType.VIEWPORT_CHANGE, viewport);

export type StoresMapAction =
    | ReturnType<typeof openMapPageAction>
    | ReturnType<typeof closeMapPageAction>
    | ReturnType<typeof fetchStoresSuccessAction>
    | ReturnType<typeof fetchStoresErrorAction>
    | ReturnType<typeof viewportChangeActon>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof changeFilterParamsAction>;
